import { render } from "./NotificationTalkButton.vue?vue&type=template&id=544a0a78"
import script from "./NotificationTalkButton.vue?vue&type=script&lang=js"
export * from "./NotificationTalkButton.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1697103798/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__